import * as React from 'react';

const VerifiedBadgeIcon = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}>
      <g clipPath="url(#a)">
        <path
          d="M16 8L14.225 6.045L14.473 3.469L11.847 2.883L10.473 0.64L8 1.664L5.527 0.64L4.153 2.879L1.527 3.465L1.775 6.035L0 8L1.775 9.96L1.527 12.538L4.153 13.124L5.527 15.358L8 14.321L10.473 15.353L11.847 13.117L14.473 12.531L14.225 9.96L16 8ZM6.611 11.309L3.847 8.638L4.924 7.601L6.611 9.232L10.865 5.119L11.942 6.157L6.611 11.309Z"
          fill={props?.verifiedColor}
        />
      </g>
      <defs>
        <clipPath id="a">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default VerifiedBadgeIcon;
